import React from "react";
import { Link } from "react-router-dom";

const Hero: React.FC = () => {
  return (
    <div className="relative bg-gray-900">
      {/* Hero background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-primary to-secondary opacity-70"></div>
      </div>

      {/* Hero content */}
      <div className="relative container-custom py-20 md:py-32">
        <div className="max-w-3xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            Empowering Women, Educating Communities, Promoting Health
          </h1>
          <p className="text-xl text-white/90 mb-8">
            We strive to empower every individual for a healthy life through
            initiatives such as women empowerment, skill development, rural
            sanitation, Clean India Campaigns, and cancer-related health
            programs.
          </p>
          <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
            <Link to="/donate" className="btn-primary text-center text-lg">
              Donate Now
            </Link>
            <div className="text-white text-center sm:text-left mt-2 sm:mt-0">
              <p className="text-sm font-medium">100% Secure Donation</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
